import clsx from 'clsx'
import { Link } from 'react-router-dom'
import Icon from 'src/components/icons/icon'

export interface LinkItem {
  path?: string
  label?: string
  iconName?: string
  isActive?: boolean
  isDivider?: boolean
  isDisabled?: boolean
  isSectionHeader?: boolean
  isBack?: boolean
  isExternal?: boolean
  onClick?: (e: React.MouseEvent) => void
  // Used when extra paths are nested under the main path
  additionalMatchingPaths?: string[]
  dataTour?: string
  state?: Record<string, unknown>
}

export function SideNavLinkItem({ linkItem }: { linkItem: LinkItem }) {
  const {
    path,
    label,
    iconName,
    isActive,
    isSectionHeader,
    isDivider,
    isBack,
    isDisabled,
    isExternal,
    onClick,
    dataTour,
    state,
  } = linkItem
  if (isDivider) {
    return <div className='mx-4 my-2 border-0 border-b' />
  }

  if (isSectionHeader) {
    return <div className='h6 text-faint mx-4 my-2 text-xs'>{label}</div>
  }

  return (
    <Link
      to={path!}
      aria-label={label}
      data-tour={dataTour}
      onClick={onClick}
      state={state}
      {...(isExternal && { target: '_blank' })}
    >
      <div
        className={clsx(
          isBack && 'text-brand',
          isActive && 'bg-tint text-brand',
          isDisabled && 'text-faint cursor-not-allowed',
          'hover:bg-tint hover:text-brand mb-[2px] flex h-12 items-center gap-4 rounded-lg px-4 transition-colors duration-300',
        )}
      >
        {iconName && <Icon name={iconName!} size={20} />}
        <div className='text-sm font-bold leading-tight'>{label}</div>
      </div>
    </Link>
  )
}
